import useSendPasswordResetEmail from '../../../../../hooks/useSendPasswordResetEmail'
import { primaryServices } from '../../../../../utils/firebaseServiceContext'

export const usePasswordActions = () => {
  const sendPasswordResetEmail = useSendPasswordResetEmail()

  const handleChangePassword = () => {
    const email = primaryServices.auth.currentUser?.email
    if (!email) return
    sendPasswordResetEmail(email)
  }

  return {
    handleChangePassword,
  }
}
